/// <amd-module name="VSSUI/Measure" />
export { Measure } from "./Components/Measure/Measure";
export { IMeasureProps } from "./Components/Measure/Measure.Props";
